module.exports = __webpack_public_path__ + "img/455.8d4c09cc.jpg";